<template>
    <div class="page userPage">
        <el-row>
            <el-col :span="6" class="left-box">
                <ui-panel class="ui-panel" :title="$t('c.organizations')" icon="inuc-organization">
                    <a :href="href" ref="downLoad" id="export-a"></a>
                    <a :href="hrefT" ref="downLoadT" id="export-b"></a>
                    <div slot="button" class="operate">
                        <el-tooltip class="item" effect="dark" :content="$t('system.addOrg')" placement="top"
                                    :hide-after="1000">
                            <i class="nucfont inuc-add-circle" @click="addOrg('orgForm')"></i>
                        </el-tooltip>
                        <!--<el-tooltip class="item" effect="dark" :content="$t('system.importOrg')" placement="top"-->
                                    <!--:hide-after="1000">-->
                            <!--<label class="org-import-btn" @change="importOrg($event)">-->
                                <!--<i class="nucfont inuc-import"></i>-->
                                <!--<input type="file" accept=".xls,.xlsx">-->
                            <!--</label>-->
                        <!--</el-tooltip>-->
                        <!--<el-tooltip class="item" effect="dark" :content="$t('c.downTemplate')" placement="top"-->
                                    <!--:hide-after="1000">-->
                            <!--<i class="nucfont inuc-download" @click="downloadTemplate"></i>-->
                        <!--</el-tooltip>-->
                        <el-tooltip class="item" effect="dark" :content="$t('system.exportOrg')" placement="top"
                                    :hide-after="1000">
                            <i class="nucfont inuc-daochu" @click="exportOrg('ruleCard')"></i>
                        </el-tooltip>
                    </div>

                    <div class="tree-container" id="treeContainer">
                        <select-SingleOrg
                            :isTreePop="false"
                            @noData="noData"
                            @dataLoaded="orgLoaded"
                            v-on:getTreeNodeData="getNodeVal">
                        </select-SingleOrg>
                    </div>
                </ui-panel>
            </el-col>

            <el-col :span="8" class="right-box">
                <ui-panel class="ui-panel" :title="title" icon="inuc-list-chart"
                          :icon="isAddOrg ?'inuc-add': 'inuc-list-chart'">
                    <div slot="button" class="operate">
                        <span class="nucfont inuc-delete" v-show="!isEdit" @click="deleteOrg"
                              :title="$t('c.delete')"></span>
                        <span class="nucfont inuc-edit" v-show="!isEdit" @click="statusEdit"
                              :title="$t('c.edit')"></span>
                    </div>

                    <el-form :rules="rules" ref="orgForm" :model="orgForm"
                             class="animated" :class="isEdit ? 'bounceInRight':'bounceInLeft'">
                        <el-form-item :label="$t('system.orgName')" prop="name">
                            <el-input :placeholder="$t('tip.orgName')" v-model="orgForm.name" :disabled="!isEdit"
                                      :clearable="isEdit"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('c.belong')" prop="superiorName">
                            <el-popover
                                ref="popovertree"
                                placement="right-start"
                                trigger="click"
                                :disabled="!isEdit">
                                <select-SingleOrg
                                    class="tree-container-pop"
                                    style="width: 300px"
                                    :isTreePop="true"
                                    v-on:getTreeNodeData="getNodeValPop"
                                ></select-SingleOrg>
                                <el-input
                                    v-model="orgForm.superiorName"
                                    :disabled="!isEdit"
                                    :clearable="isEdit"
                                    @clear="clearSuperior"
                                    :readonly="!isAddOrg"
                                    slot="reference" :placeholder="$t('tip.belong')">
                                </el-input>
                            </el-popover>
                        </el-form-item>
                        <el-form-item :label="$t('c.NO')" prop="order">
                            <el-input-number controls-position="right" v-model="orgForm.order" :disabled="!isEdit"
                                             :precision="0" size="mini" :min="0" :max="500"></el-input-number>
                        </el-form-item>
                        <el-form-item :label="$t('system.orgDesc')" prop="description">
                            <el-input type="textarea" v-model="orgForm.description" :autosize="{ minRows: 2}"
                                      :disabled="!isEdit" :placeholder="$t('tip.input')"></el-input>
                        </el-form-item>
                        <el-form-item v-if="orgForm.createTime" :label="$t('c.creationTime')+'：'" style="margin: 0;">
                            {{orgForm.createTime ? orgForm.createTime.split(" ")[0] : ""}}
                        </el-form-item>
                        <el-form-item v-if="orgForm.modifyTime" :label="$t('c.modificationTime')+'：'"
                                      style="margin: 0;">
                            {{orgForm.modifyTime ? orgForm.modifyTime.split(" ")[0] : ""}}
                        </el-form-item>
                        <el-form-item style="text-align: center" v-if="isEdit">
                            <el-button type="primary" @click="submitForm">{{isAddOrg ? $t('c.add') : $t('c.save')}}
                            </el-button>
                            <el-button @click="cancelEdit">{{isAddOrg ? $t('c.reset') : $t('c.cancel')}}</el-button>
                        </el-form-item>
                    </el-form>
                </ui-panel>
            </el-col>

            <el-col :span="8" class="right-box">
                <ui-panel class="ui-panel" :title="$t('system.memberList')" icon="inuc-members">
                    <el-table class="form-table"
                              ref="userTable"
                              :data="userData"
                              :border="false"
                              :stripe="true"
                              height="100%"
                    >
                        <!-- column title -->
                        <el-table-column property="name" :label="$t('c.username')" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column property="accountNo" :label="$t('c.account')" align="center"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column property="typeName" :label="$t('c.occupation')" width="110px" align="center"
                                         sortable>
                            <template slot-scope="scope">
                                <span class="type-bg" :class="typeBg(scope.row.type)">{{scope.row.typeName}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column property="isDelete" :label="$t('train.userStatus')" width="110px" align="center"
                                         sortable>
                            <template slot-scope="scope">
                                <span v-if="scope.row.isDelete" style="color:#ff4e4e">{{$t('system.disabled')}}</span>
                                <span v-else>{{$t('system.enabled')}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </ui-panel>
            </el-col>

        </el-row>

    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket} from '@/utils';
    import selectSingleOrg from '@/components/SelectSingleOrg'
    import uiPanel from '@/components/UIPanel';

    export default {
        data() {
            return {
                title: this.$t('system.orgDetail'),
                isAddOrg: false,
                orgForm: {
                    name: "",
                    order: 0,
                    description: "",
                    superiorName: "",
                    superiorID: 0,
                },
                rules: {
                    name: [
                        {required: true, message: this.$t('tip.orgName'), trigger: 'blur'},
                        {min: 1, max: 30, message: this.$t('rule.lengthBetween', ['1', '30']), trigger: 'blur'}
                    ],
                    description: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'}
                    ]
                },
                currentNodeVal: {},
                isEdit: false,
                userData: [],
                href: undefined,
                hrefT: undefined,
            }
        },
        created() {},
        mounted(){},
        computed: {},
        methods: {
            orgLoaded() {
                setTimeout(function () {
                    $("#treeContainer").find(".el-tree-node__content").eq(0).click()
                }, 300)
            },

            addOrg(orgForm){
                this.statusAdd();
                this.title = this.$t('system.addOrg');
                this.$refs[orgForm] && this.$refs[orgForm].resetFields();

                this.orgForm = {
                    name: "",
                    order: 0,
                    description: "",
                    superiorName: this.currentNodeVal.name,
                    superiorID: this.currentNodeVal.id,
                };

                //this.currentNodeVal = {};
            },
            //树列表的获取数据方法处理
            getNodeVal(data){
                let that = this;
                this.orgForm = {...data};
                this.currentNodeVal = {...data};
                this.statusReadonly();

                this.title = this.$t('system.orgDetail');
                this.$refs["orgForm"].clearValidate();

                api.getOrgMembers(data.id, {
                    PageNO: 1,
                    Limit: -1,
                }).then(res => {
                    this.userData = res.package
                });

                // xia 18/9/7 非编辑模式下不显示placeholder
                !this.orgForm.description && (this.orgForm.description = this.$t('c.none'));
                !this.orgForm.superiorID && (this.orgForm.superiorName = this.$t('c.none'));

                //所属机构的联动
                $(".tree-container-pop .el-tree-node__label").each(function () {
                    $(this).parent(".el-tree-node__content").removeClass("pink");
                    if ($(this).text() == that.orgForm.superiorName) {
                        $(this).parent(".el-tree-node__content").addClass("pink");
                    }
                })
            },

            //所属机构的获取数据的方法处理
            getNodeValPop(data){
                this.$set(this.orgForm, 'superiorName', data.name);
                this.$set(this.orgForm, 'superiorID', data.id);
            },
            submitForm(){
                this.$refs["orgForm"].validate((valid) => {
                    if (!valid) return;

                    if (this.isAddOrg) {
                        if (!this.orgForm.superiorID) {
                            delete this.orgForm.superiorID;
                            delete this.orgForm.superiorName;
                        }

                        api.postOrganizationDetail(this.orgForm).then(res => {
                            this.freshTree(res.package);
                            this.success(this.$t('m.operateSuccess'));
                        });
                    } else {
                        let orgId = this.orgForm.id;
                        if (!this.orgForm.superiorName || !this.orgForm.superiorID) {
                            this.orgForm.superiorName = null;
                            this.orgForm.superiorID = null;
                        }

                        api.putOrganizationDetail(orgId, this.orgForm).then(res => {
                            this.freshTree(orgId);
                            this.isEdit = !this.isEdit;
                            // this.currentNodeVal = {...this.orgForm};
                            this.success(this.$t('m.operateSuccess'));
                        });
                    }
                })
            },
            statusAdd() {
                this.isEdit = true;
                this.isAddOrg = true;
            },
            statusEdit(){
                this.isEdit = !this.isEdit;
                this.isAddOrg = false;
            },
            statusReadonly() {
                this.isEdit = false;
                this.isAddOrg = false;
            },
            deleteOrg(){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteOrganizationDetail(this.orgForm.id).then(res => {
                        this.freshTree();
                        this.currentNodeVal = {};
                        this.addOrg();

                        this.success(this.$t('m.operateSuccess'));
                        $(".tree-container .red").removeClass("red");
                    });
                }).catch(() => {
                });

            },
            //模板下载
            downloadTemplate(){
                let culture=this.$i18n.locale;
                let ticket = Ticket.get().access_token;

                this.hrefT=APIURI + `api/Download/UserTemplate?culture=${culture}&ui-culture=${culture}&access_token=${ticket}`
                this.$nextTick(() => {
                    $('#export-b')[0].click();
                });
            },
            //组织机构导入
            importOrg(e){
                let file = e.target.files[0];
                let formData = new FormData();      //创建form对象
                formData.append('file', file);      //通过append向form对象添加数据
                api.uploadOrg(formData).then(res => {
                    this.$message.success(res.message)
                    e.target.value = '';
                    this.freshTree();
                    //this.orgLoaded();
                }).catch(() => {
                    // 出错时清空文件，不然无法触发change
                    e.target.value = '';
                })
            },
            //组织机构导出
            exportOrg(formName) {
                const ticket = Ticket.get().access_token;
                let culture=this.$i18n.locale;
                this.href = APIURI + `api/Export/excel/organization?access_token=` + ticket + `&culture=${culture}&ui-culture=${culture}`;
                this.$nextTick(() => {
                    $('#export-a')[0].click();
                });
            },
            clearSuperior() {
                this.orgForm.superiorID = 0;
            },
            cancelEdit(){
                if (this.isAddOrg) {
                    this.$refs["orgForm"].resetFields();
                    this.clearSuperior();
                } else {
                    this.isEdit = !this.isEdit;
                    this.orgForm = {...this.currentNodeVal};
                    this.$refs["orgForm"].clearValidate();
                }
            },
            freshTree(id) {
                this.$store.dispatch('getOrgTree').then(d => {
                    if (id) {
                        this.$nextTick(() => {
                            let node = $('.left-box').find(`.id_${id}`).closest('.el-tree-node__content');
                            node.click();
                        })
                    }
                })

            },

            typeBg(type){
                let typeColor = ''
                switch (type) {
                    case 2:
                        typeColor = 'trainer';
                        break;
                    case 3:
                        typeColor = 'student';
                        break;
                    case 1:
                        typeColor = 'admin';
                        break;
                    default:
                        typeColor = ''
                }
                return typeColor
            },

            noData() {
                this.isEdit = true;
                this.isAddOrg = true;
                this.title = this.$t('system.addOrg');
            },
            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        watch: {
            // xia 18/9/7 非编辑模式下不显示placeholder
            isEdit(val) {
                if (this.isAddOrg) return

                if (!val) {
                    !this.orgForm.description && (this.orgForm.description = this.$t('c.none'));
                    !this.orgForm.superiorID && (this.orgForm.superiorName = this.$t('c.none'));
                } else {
                    this.orgForm = {...this.currentNodeVal};
                }
            }
        },
        components: {
            selectSingleOrg,
            uiPanel
        }
    }
</script>
<style>
    .popblue {
        border: 1px solid rgb(0, 188, 212);
    }
</style>
<style scoped lang="scss">
    @import '../../style/const.scss';

    .userPage {
        //background-color: #fff;
    }

    .userPage > .el-row {
        height: 100%;
        min-height: 560px;

        .el-col {
            height: 95%;
            background-color: #fff;
        }
    }
    .org-import-btn{
        > input {
            display: none;
        }
    }
    .ui-panel {
        height: 100%;
        position: relative;
        background-color: #fff;
        border-color: #ddd;

        /deep/ .panel-body {
            height: 95%;
            background: none;
        }

        .operate {
            position: absolute;
            right: 20px;
            .item{
                margin-left: 10px;
            }
            .nucfont {
                color: #a3a4a9;
                font-size: 18px;
                cursor: pointer;
                &:hover {
                    color: #ff4081;
                }
            }
        }
    }

    .left-box {
        /deep/ .panel-body {
            padding: 5px 0;
        }

        .tree-container {
            overflow-y: auto;
            height: 100%;
            background-color: #fff;
            padding: 12px;

            .tree-container-pop {
                width: auto;

                /deep/ .org-tree {
                    max-height: none;
                }
            }
        }
    }

    .right-box {
        margin-left: 20px;

        /deep/ .panel-body {
            padding: 10px 20px;
        }

        .nucfont {
            margin-left: 15px;
            float: right;
            &:hover {
                color: $color-theme !important;
            }
        }
    }

    .type-bg {
        display: inline-block;
        width: 80px;
        border-radius: 1px;
        color: #fff;
        &.trainer {
            background-color: #2e7faa;
        }
        &.student {
            background-color: #ffb822;
        }
        &.admin {
            background-color: #f4516c;
        }
    }
</style>

